import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { of as observableOf,  Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { TokenService } from './token.service';
import { UserService } from './user.service';
import { CustomerService } from './customer.service';
import { StrategiesPermissionsService } from '../../strategies/services/strategies-permissions.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DeepLinkGuardService implements CanActivate {

  constructor(private router: Router, private authService: AuthService, private tokenService: TokenService,
              private userService: UserService, private customerService: CustomerService,
              private strategiesPermissionsService: StrategiesPermissionsService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const authToken = route.queryParams.authToken;
    const customerId = parseInt(route.queryParams.customerId, 10);
    if (!authToken) {
        window.open(environment.my_journey_url + environment.logoutEndPoint, '_self');
        return observableOf(false);
    } else {
      return new Observable<boolean>(observer => {
        this.authService.login({authorizationToken: authToken}).subscribe(
          res => {
            this.tokenService.token = res.token;
            this.userService.user = res.user;
            this.strategiesPermissionsService.populateSuperAdminRoleAndPermissions();
            const userAssociatedWithInst = this.userService.user.userAssociations.find(
              association => association.institutionId === customerId
            );
            if (userAssociatedWithInst || this.strategiesPermissionsService.isUserSuperAdmin()) {
              this.customerService.getInstitutionMetaData(customerId).subscribe(
                customer => {
                  this.customerService.institution = customer;
                  this.strategiesPermissionsService.populateUserInstitutionRoleAndPermissions();
                  const nextUrl = this.authService.redirectUrl;
                  this.router.navigate([nextUrl]);
                  this.authService.redirectUrl = null;
                  observer.next(false);
                },
                err => {
                  this.router.navigate(['/select-institution']);
                  observer.next(false);
                }
              );
            } else {
              this.router.navigate(['/select-institution']);
              observer.next(false);
            }
          },
          err => {
              window.open(environment.my_journey_url + environment.logoutEndPoint, '_self');
              observer.next(false);
          });
      });
    }
  }
}
